import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';
import type { SnakeCasedPropertiesDeep } from 'type-fest';

export enum ProductType {
  Analytics = 'analytics_product',
  Feedback = 'feedback_product',
}

export interface AnalyticsProduct {
  dailyCcSessions: number;
  dailySessions: number;
  selfServeEnabled: boolean;
  sku: string;
  tier: FeatureGroup;
  type: ProductType.Analytics;
}

export interface FeedbackProduct {
  type: ProductType.Feedback;
  sku: string;
  monthlyResponses: number;
  tier: FeatureGroup;
  selfServeEnabled: boolean;
}

export type Product = AnalyticsProduct | FeedbackProduct;

export interface ProductCatalog {
  analyticsProducts: AnalyticsProduct[];
  feedbackProducts: FeedbackProduct[];
}

export type AnalyticsProductDto = SnakeCasedPropertiesDeep<AnalyticsProduct>;

export type FeedbackProductDto = SnakeCasedPropertiesDeep<FeedbackProduct>;

export type ProductCatalogDto = SnakeCasedPropertiesDeep<ProductCatalog>;
